<ng-container *ngIf="!!element?.anexo_principal">
  <div
    class="flex w-full justify-center rounded-tl-2xl bg-white px-10 pt-10 shadow-xl"
    [ngClass]="{
      'rounded-tr-2xl': fullWidth || fullSize,
      'rounded-bl-2xl rounded-br-2xl': fullSize
    }"
  >
    <img class="w-auto rounded-lg" [src]="element.anexo_principal.file" [alt]="element.anexo_principal.nome_arquivo" />
  </div>
</ng-container>
